// update state
const setFoldersNotificationsCountAction = (payload) => {
    return {
        type: "NOTIFICATIONSFOLDER",
        payload
    }
}

export default setFoldersNotificationsCountAction;


// WEBPACK FOOTER //
// ./src/actions/setFoldersNotificationsCountAction.js